import $ from 'jquery';
import L from 'leaflet'
import 'leaflet.markercluster';
import { GestureHandling } from 'leaflet-gesture-handling';
import 'leaflet/dist/leaflet.css'
import 'leaflet-gesture-handling/dist/leaflet-gesture-handling.css';
import 'leaflet.markercluster/dist/MarkerCluster.css';
import 'leaflet.markercluster/dist/MarkerCluster.Default.css';
import 'select2';
import fr from 'select2/src/js/select2/i18n/fr';

// eslint-disable-next-line no-undef
const object = gralObject;

var mapsPlaceholder = [];


if ($('.distributors-map').length) {
    L.Map.addInitHook('addHandler', 'gestureHandling', GestureHandling);
    L.Map.addInitHook(function () {
        mapsPlaceholder.push(this); // Use whatever global scope variable you like.
    });

    const distributorsMap = L.map('distributors', {
        gestureHandling: true,
        attributionControl: false,
        // Bornes portées par la carte et non plus par le calque de tuiles :
        // markercluster exige un maxZoom fini, et le rendu vectoriel se
        // désynchronise de Leaflet au zoom 0.
        minZoom: 1,
        maxZoom: 18,
    }).setView(object.mapLocation, object.mapZoom);

    // Tuiles raster de secours : libellés dans la langue locale du pays, non
    // traduisibles (l'image est pré-rendue côté serveur).
    const addRasterBasemap = () => {
        L.tileLayer('https://basemaps.cartocdn.com/rastertiles/light_all/{z}/{x}/{y}.png?key={accessToken}', {
            attribution: '',
            id: object.mapBoxID,
            accessToken: object.cartoKey,
        }).addTo(distributorsMap);
    };

    // Fond de carte vectoriel : permet d'afficher les noms de pays, régions et
    // villes en français (Allemagne, Espagne, Vienne...). Chargé dynamiquement
    // pour garder maplibre-gl hors du bundle principal.
    import(/* webpackChunkName: "localized-basemap" */ '../elements/localized-basemap')
        .then(({ addLocalizedBasemap }) => addLocalizedBasemap(distributorsMap, object.mapLang))
        .catch(() => addRasterBasemap());

    const markerIcon = L.icon({
        iconUrl: `${object.publicPath}/img/marker.svg`,
        shadowUrl: '',
        iconSize: [24, 33],
        shadowSize: '',
        iconAnchor: [12, 33],
        shadowAnchor: '',
        popupAnchor: [1, -35],
    });

    const popupTemplate = (distributor) => {
        let socials = '';

        for (const key in distributor.socials) {
            if (distributor.socials[key] === '') {
                continue;
            }

            socials += `<a href="${distributor.socials[key]}" target="_blank" rel="noopener noreferrer"><i class="gral-icons-${key}"></i></a>`;
        }

        return (
            `<div class="dist-popup">` +
            `<span class="dist-popup__title">${distributor.title}</span>` +
            `<span class="dist-popup__address">${distributor.address}</span>` +
            `${distributor.tel && `<a href="tel:${distributor.tel}" class="dist-popup__tel"><strong>${object.tel}</strong> ${distributor.tel}</a>`}` +
            `${distributor.email && `<a href="mailto:${distributor.email}" class="dist-popup__button dist-popup__button--email">${object.emailContact}</a>`}` +
            `${distributor.website && `<a href="${distributor.website}" class="dist-popup__button dist-popup__button--website" target="_blank" rel="noopener noreferrer">${object.website}</a>`}` +
            `<a href="https://www.google.com/maps?saddr=My+Location&daddr=${distributor.coordinates}" class="dist-popup__button dist-popup__button--route" target="_blank" rel="noopener noreferrer">${object.route}</a>` +
            `<div class="dist-popup__social">` +
            socials +
            `</div>` +
            `</div>`
        );
    };

    const clusterGroup = L.markerClusterGroup();

    // eslint-disable-next-line no-undef
    // distributors.map((distributor) => {
    //     clusterGroup.addLayer(
    //         L.marker(distributor.coordinates.split(','), {
    //             icon: markerIcon,
    //         }).bindPopup(popupTemplate(distributor))
    //     );
    // });

    // eslint-disable-next-line no-undef
    distributors.map((distributor) => {
        L.marker(distributor.coordinates.split(','), { icon: markerIcon , coordinates: distributor.coordinates}).addTo(distributorsMap).bindPopup(popupTemplate(distributor));
    });

    distributorsMap.addLayer(clusterGroup);

    let coords = [];
    // eslint-disable-next-line no-undef
    distributors.map((distributor) => {
        coords.push(distributor.coordinates.split(','));
    });

    if (coords.length > 0) {
        //distributorsMap.fitBounds(coords);
        //distributorsMap.zoomOut(0.1);
        distributorsMap.fitBounds(coords, {padding:[70, 70]});
        distributorsMap.zoomOut(0.1);
    }

    $('.distributors-map-toggle').on('click', function () {
        $('.distributors-map').toggleClass('distributors-map--active');
    });
}

const dists = $('.distributors-select2');
let vals = new Object();

dists.select2({
    language: fr,
    dropdownParent: $('.filter__search'),
});

const getTaxes = (el) => {
    const type = el.attr('data-type');

    $.ajax({
        url: object.ajaxUrl,
        type: 'POST',
        dataType: 'JSON',
        data: {
            action: 'gral_get_distributors_taxes',
            nonce: object.nonce,
            type,
            vals,
        },
        success: (res) => {
            if ('region' === type) {
                const region = $('.distributors-select2[data-type=region]');
                const department = $('.distributors-select2[data-type=departement]');
                region.empty().trigger('change');
                department.empty().prop('disabled', true).trigger('change');
            }

            if (res.success) {
                res.data.data.map((val) => {
                    if (!el.find(`option[value=${val.id}]`).length) {
                        el.append(`<option value="${val.id}" data-pays="${val.country}" data-region="${val.region}">${val.text}</option>`);
                    }
                });
            }

            el.trigger('change');

            if ('region' === type) {
                const el = $('.distributors-select2[data-type=region]');
                el.prop('disabled', false);
            }

            if ('departement' === type) {
                const el = $('.distributors-select2[data-type=departement]');
                el.prop('disabled', false);
            }
        },
    });
};

dists.on('select2:select', function () {
    dists.each(function () {
        vals[$(this).attr('data-type')] = $(this).val();
    });

    const type = $(this).attr('data-type');

    if ('pays' === type && $(this).val()) {
        const el = $('.distributors-select2[data-type=region]');
        getTaxes(el);
    }

    if ('region' === type && $(this).val()) {
        const el = $('.distributors-select2[data-type=departement]');
        getTaxes(el);
    }
});

$('.distributors-select2').on('select2:unselect', function (e) {
    const $this = $(this);
    const type = $this.attr('data-type');
    const val = $this.val();

    if ('pays' === type) {
        const region = $('.distributors-select2[data-type=region]');
        const department = $('.distributors-select2[data-type=departement]');
        region.find(`option[data-pays=${e.params.data.id}]`).remove();
        region.trigger('change');
        department.find(`option[data-pays=${e.params.data.id}]`).remove();
        department.trigger('change');

        if (!val.length) {
            region.prop('disabled', true);
            department.empty().prop('disabled', true);
        }
    }

    if ('region' === type) {
        const department = $('.distributors-select2[data-type=departement]');
        department.find(`option[data-region=${e.params.data.id}]`).remove();
        department.trigger('change');

        if (!val.length) {
            department.prop('disabled', true);
        }
    }
});

$('.filter__autocomplete')
    .autocomplete({
        minLength: 3,
        appendTo: '.filter__wrapper',
        source: function (request, response) {
            $.ajax({
                url: object.ajaxUrl,
                type: 'POST',
                dataType: 'JSON',
                data: {
                    nonce: object.nonce,
                    action: 'gral_get_posts',
                    keyword: request.term,
                    postType: $('.filter').attr('data-post-type'),
                },
                success: function (res) {
                    response(res.data.data);
                },
            });
        },
        search: function (event) {
            $('.search_by_name_button').hide();
            $(event.target).parents('.filter').find('form .gral-loader').show();
        },
        open: function (event) {
            $('.search_by_name_button').show();
            $(event.target).parents('.filter').find('form .gral-loader').hide();
            $(event.target).addClass('autocomplete-active');
            $(document.body).css('height', '100vh');
            $(document.body).css('overflow', 'hidden');
        },
        close: function (event) {
            $(event.target).removeClass('autocomplete-active');
            $(document.body).css('height', 'unset');
            $(document.body).css('overflow', 'unset');
        },
        create: function () {
            $(this).data('ui-autocomplete')._renderItem = function (ul, item) {
                return $('<li>')
                    .append(`<button data-coordinates="${item.coord}" class="distrib-res res-class">${item.thumbnail ? `<img src="${item.thumbnail}" alt="${item.name}">` : ''}${item.title}</button>`)
                    .appendTo(ul);
            };
        },
        select: function(event, ui) {
            if ($('.distributors-map').length) {
                let map = mapsPlaceholder.pop();
                let coords = [];
                coords.push(ui.item.coord.split(','));
                map.fitBounds(coords);
                map.zoomOut(0.1);
                map.eachLayer(function (layer) {
                    if ( layer.options.coordinates && ui.item.coord) {
                        if (layer.options.coordinates === ui.item.coord) {
                            layer.openPopup();
                        }
                    }
                });
                mapsPlaceholder.push(map);
            }
        }
    })
    .focus(function () {
        $(this).data('uiAutocomplete').search($(this).val());
    });

